import React from "react";
import { Show, SimpleShowLayout, TextField, BooleanField, ReferenceField } from "react-admin";

export const CouponShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID"/>
      <ReferenceField label="Campaign" source="campaign" reference="campaigns">
        <TextField source="title"/>
      </ReferenceField>
      <BooleanField source="expired"/>
      <TextField source="code" label="Coupon code"/>
      <TextField source="description" label="Coupon description"/>
    </SimpleShowLayout>
  </Show>
);
